/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get("recently-viewed-products")) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = theme.routes.search_url + "?view=recently-viewed&type=product&q=";
      this.container = this.querySelector(".products");
      this.currentId = this.dataset.productHandle;
      this.max = this.dataset.limit || 4;
      this.products = "";
      if (window.localStorage) {
        let recentIds = window.localStorage.getItem("recently-viewed");
        if (recentIds && typeof recentIds !== undefined) {
          window.recentlyViewedIds = JSON.parse(recentIds);
        }
      }
    }
    connectedCallback() {
      this.buildUrl();
    }
    buildUrl() {
      if (!window.recentlyViewedIds || !Array.isArray(window.recentlyViewedIds)) {
        return;
      }

      let i = 0;
      window.recentlyViewedIds.forEach((val) => {
        // Skip current product
        if (val === this.currentId) {
          return;
        }
        // Stop at max
        if (i >= this.max) {
          return;
        }
        this.products += "handle:" + val + " OR ";
        i++;
      });

      this.url = this.url + encodeURIComponent(this.products);

      this.fetchProducts();
    }
    fetchProducts() {
      fetch(this.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector(".products");
          const productCards = html.querySelectorAll(".product-card");

          if (recommendations && recommendations.innerHTML.trim().length) {
            const slider = this.querySelector(".recently-viewed-slider");

            if (slider) {
              slider.innerHTML = "";

              productCards.forEach((card) => {
                const wrapper = document.createElement("div");
                wrapper.classList.add("carousel__slide");
                wrapper.appendChild(card);
                slider.appendChild(wrapper);
              });

              this.classList.add("product-recommendations--loaded");

              new Flickity(slider, {
                cellAlign: "left",
                contain: true,
                pageDots: true,
                groupCells: true,
              });

              ScrollTrigger.batch(
                ".animations-true .product-card .product-featured-image-link",
                {
                  start: "top 90%",
                  onEnter: (elements, triggers) => {
                    gsap.to(elements, {
                      scale: 1,
                      opacity: 1,
                      stagger: 0.15,
                      ease: window.theme.settings.animation_easing,
                    });
                  },
                }
              );
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  customElements.define("recently-viewed-products", RecentlyViewedProducts);
}
